// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer___S6qT","links":"styles_links__7B3E1","copyright":"styles_copyright__U50S4"};